import { Injectable } from '@angular/core';
import { Fields } from '@app/services/selective-processes/fields/fields';
import { isArray } from 'util';

export interface OptionsJsonBuilder extends Fields {
  variable_key: string
}

@Injectable({
  providedIn: 'root'
})

export class JsonBuilderService {
  private options: OptionsJsonBuilder[] = [];
  constructor() { }

  public setOptions(options: Fields[]) {
    if (isArray(options)) {
      this.options = options.map((option: Fields) => {
        return {
          ...option,
          variable_key: `#{@${option.key}@}`
        };
      })
    }
  }

  public getOptions(): OptionsJsonBuilder[] {
    return this.options;
  }
}
